"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, Search, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:!bg-transparent focus:!bg-transparent after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] after:ease-[var(--ease-smooth)] hover:after:w-full focus:after:w-full outline-none">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-t border-border shadow-medium md:hidden">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-foreground hover:bg-primary-light rounded-md transition-all duration-[var(--duration-fast)] ease-out" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 z-50 w-full border-b border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isScrolled ? "h-16 bg-background/80 backdrop-blur-md shadow-soft" : "h-[90px] bg-background"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between gap-6">
        {}
        <Link to="/HomePage#" className="shrink-0">
          <img src="https://crucial-glowworm.10web.cloud/wp-content/uploads/2026/02/SSC-LOGO.jpeg" alt="Sundaram's School of Commerce" className="!w-[50px] !h-[50px]" />
        </Link>

        {}
        <MenuProvider menu_id="17" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" className="shrink-0 hover:!bg-transparent focus:!bg-transparent hover:scale-[1.02] active:scale-100 transition-transform duration-[var(--duration-fast)] ease-out" aria-label="Search">
            <Search className="size-5" />
          </Button>

          <Button asChild className="shrink-0 hidden sm:inline-flex hover:!bg-accent-hover focus:!bg-accent-hover hover:scale-[1.02] active:scale-100 transition-all duration-[var(--duration-fast)] ease-out">
            
          </Button>
        </div>
      </div>
    </header>;
}